export enum CustomerType {
  INDIVIDUAL = "INDIVIDUAL",
  CORPORATE = "CORPORATE",
}

export const customerTypeOptions = [
  {
    label: "Privat",
    value: CustomerType.INDIVIDUAL,
  },
  {
    label: "Gewerblich",
    value: CustomerType.CORPORATE,
  },
];
